import Icon from '../components/Icon.vue'

Icon.register({
  'house-damage': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 115L69.5 307.7C67.8 309.2 65.8 309.9 64 311.1V496C64 504.8 71.2 512 80 512H229.2L192 439.2 296.1 375.2 235.9 256 384 392.8 279.9 456.8 319.8 512H496C504.8 512 512 504.8 512 496V311.1C510.3 309.9 508.3 309.3 506.7 307.9L288 115zM570.7 236.3L512 184.4V48C512 39.2 504.8 32 496 32H432C423.2 32 416 39.2 416 48V99.7L314.8 10.3C307.1 3.4 297.6 0 288 0S268.9 3.4 261.3 10.3L5.3 236.3C-1.3 242.2-1.8 252.3 4.1 258.9L25.5 282.7C31.4 289.3 41.5 289.8 48.1 283.9L277.4 81.6C283.5 76.3 292.5 76.3 298.6 81.6L527.9 283.9C534.5 289.8 544.6 289.3 550.5 282.7L571.9 258.9C577.8 252.3 577.3 242.2 570.7 236.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/house-damage.js
// module id = Os+q
// module chunks = 144